import { useAsyncState } from '@vueuse/core';
import { computed } from 'vue';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { EnumDocumentType } from '@getaccept/lib-shared/src/enums/DocumentType';
import Analytics from '@getaccept/lib-shared/src/analytics';
import { useToast } from '@getaccept/fried-tofu';
import { AnalyticsEvent } from '@getaccept/lib-shared/src/types/analytics';
import { useAppMode } from '../../composables/app-mode.composable';
import { CreateDocumentService } from '../services/create-document.service';
import type { InitialDocument } from '../types/create-document-types';

export const useCreateInitialDocument = () => {
  const { toast } = useToast();

  const { isSales: isSalesAppMode } = useAppMode();
  const documentType = computed(() =>
    isSalesAppMode.value ? EnumDocumentType.Sales : EnumDocumentType.Hr
  );

  const createDocument = async (): Promise<InitialDocument> => {
    try {
      const id = await CreateDocumentService.createDocument(documentType.value);

      Analytics.track(AnalyticsEvent.CreatedDocument, { documentType: documentType.value });
      return await CreateDocumentService.getInitialDocument(id);
    } catch (error) {
      console.error(error);
      toast.danger(t('something-went-wrong'));
    }
  };

  return useAsyncState(createDocument, null, {
    onError: () => {
      toast.danger(t('something-went-wrong'));
    },
    immediate: false,
  });
};
